export default __webpack_public_path__ + "static/media/post-image3.95567cd3.jpg";